import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Generates the URL for editing a trip.
 * Use this for declarative navigation (Link/Button href).
 */
export function getEditTripUrl(tripId: string): string {
  return `/trips/${tripId}`;
}

/**
 * Web-specific hook for handling navigation on My Trips page.
 * Encapsulates React Router navigation logic.
 */
export function useMyTripsNavigation() {
  const navigate = useNavigate();

  const navigateToEditTrip = useCallback(
    (tripId: string) => {
      navigate(getEditTripUrl(tripId));
    },
    [navigate],
  );

  return {
    navigateToEditTrip,
    getEditTripUrl,
  };
}
